/**
 * back-to-top.js — Benigno Shopper
 * O botão só aparece quando o footer entra no viewport
 * (faixa de benefícios ou, como fallback, o <footer> principal).
 * Usa IntersectionObserver — zero custo de scroll listener.
 */
(function () {
  'use strict';

  const BTN_ID = 'BackToTopBtn';

  function init() {
    const btn = document.getElementById(BTN_ID);
    if (!btn) return;

    // Ancora no primeiro elemento do rodapé.
    // .footer-benefits é a faixa logo acima do <footer> principal.
    const anchor =
      document.querySelector('.footer-benefits') ||
      document.querySelector('footer.footer') ||
      document.querySelector('footer');

    if (!anchor) return;

    // Mostra o botão assim que qualquer pixel do footer entrar na tela.
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            btn.classList.add('is-visible');
          } else {
            btn.classList.remove('is-visible');
          }
        });
      },
      {
        threshold: 0,      // dispara no primeiro pixel visível
        rootMargin: '0px', // sem antecipação — exatamente na borda da tela
      }
    );

    observer.observe(anchor);

    // Clique: scroll suave ao topo + fecha o botão imediatamente
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      btn.classList.remove('is-visible');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
